import { render, staticRenderFns } from "./ShowHideText.vue?vue&type=template&id=c38df08a&"
import script from "./ShowHideText.vue?vue&type=script&lang=js&"
export * from "./ShowHideText.vue?vue&type=script&lang=js&"
import style0 from "./ShowHideText.vue?vue&type=style&index=0&id=c38df08a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports